<!-- <app-stanc-loader></app-stanc-loader> -->

<div class="row m-0 h-100 login_container">
  <div class="col-12 col-sm-12 col-md-7 col-lg-7 col-xl-7 LoginBg setPadding ">
    <div class="row m-0 h-100 login">
      <div class="row_tab">
        <app-header></app-header>
        <div class="mainform">
          <div class="title col-12 align-self-center">
            <h3 class="mb-4">LOGIN TO YOUR ACCOUNT</h3>
          </div>
          <div>
            <form class="blue_rectangle" [formGroup]='LoginDetails' autocomplete="off">
              <div class="row m-0">
                <div class="col-12 p-0 email">
                  <mat-form-field class="col-12">
                    <input type="email" matInput required placeholder="Email Address" formControlName="user_email"
                      autocomplete="nope">
                  </mat-form-field>
                </div>
                <div class="col-12 p-0">
                  <mat-form-field class="col-12">
                    <input matInput [type]="hide ? 'password' : 'text'" required placeholder="Password"
                      formControlName='user_password' autocomplete="new-password">
                    <span mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'"
                      [attr.aria-pressed]="hide">
                      <mat-icon class="eyeview">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                    </span>
                  </mat-form-field>
                </div>
                <!-- <div class="col-sm-6 col-6  p-0">
                  <mat-checkbox class="col-12">Remember me</mat-checkbox>
                </div> -->
                <div class="col-sm-6 col-6 p-0 ">
                  <span class="col-12 pointer " (click)="forgotPwd();">
                    Forgot password ?
                  </span>
                </div>
              </div>
                  <div class="buttonpadding text-right">
                    <button (click)='Login()' class="btn_padding" [disabled]="!this.LoginDetails.valid" mat-raised-button
                      color="primaryCus">LOGIN</button>
                  </div>
            </form>
          </div>
          <!-- <div class="register">
            <p>Are you a New User to StandardC ? </p>
            <p><a [routerLink]="['/createaccount']"> Create Account</a></p>
          </div> -->
        </div>
      </div>
      <div class="col-12">
        <app-footer></app-footer>
  
          </div>
    </div>
  </div>
  <div class="col-sm-12 col-md-5 col-lg-5 col-xl-5 pos-rel welcomeBgNew h-100">
<app-sidescreen></app-sidescreen>
</div>